import { render } from "./App.vue?vue&type=template&id=6fc3c1ff"
const script = {}

import "./App.vue?vue&type=style&index=0&id=6fc3c1ff&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__